import { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "../styles/Navigation.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import logoGrouping from '../assets/logoGrouping.png';
import tofProfil from '../assets/profile.png';
import menu from '../assets/menu.png';
import annonce from '../assets/mobile/plus.png'
import Modal from 'react-bootstrap/Modal';
import SectionConnexion from "./SectionConnexion";
import SectionTracking from "./SectionTracking";
import useUserSession from './useUserSession';
import { RiMenuUnfold4Fill, RiMenuFold4Fill } from "react-icons/ri";
import { FiPlusCircle } from "react-icons/fi";
import MenuMobile from "./MenuMobile";
import { useTranslation } from 'react-i18next';
import logoOmbre from '../assets/logoOmbre.svg'
import { firebaseSignOut } from './firebaseConfig';
import { clearSession, getSessionData, getToken } from './sessionManager';
import io from 'socket.io-client';

function Navigation({ data, error, setGoogleCon, googleCon}) {

    const { user, loading, setUser, nbnotif, setNbnotif } = useUserSession();
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
  // state permettant de changer la langue
  const [selectedLang, setSelectedLang] = useState(i18n.language === 'en' ? 'EN' : 'FR');
  const langs = ['FR', 'EN'];
  //state permettant de stocker la valeur qui permet d'afficher ou non l'icon de connexion
  const [isCon, setIsCon]= useState(false);
  // state permettant d'afficher le popup de connexion
  const [modalShow, setModalShow] = useState(false);
  // state permettant d'afficher le popup de la carte
  const [modalShow2, setModalShow2] = useState(false);
  //state permettant d'afficher ou non le nombre de notifications
  const [showNotif, setShowNotif] = useState(true)
  //state permettant de masquer ou d'afficher certains elements du menu
  const [isAnnonce, setIsAnnonce]=useState(false)
  //state permettant de masquer ou d'afficher certains elements du menu dans la page /showGoChat
  //const [isShowGoChat, setIsShowGoChat]=useState(false)
  // state permettant d'afficher le popup du menu version mobile
  const [modalShow3, setModalShow3] = useState(false);
  // state pour les notifications
  const [notifications, setNotifications] = useState([]);
  const [notifLoaded, setNotifLoaded] = useState(false);
  // state pour le modal de félicitations
  const [showCongrats, setShowCongrats] = useState(false);
  const prevUser = useRef(user);
  
  useEffect(() => {
    if (isCon) {
      handleModalHide()
    }
    // Afficher le modal de félicitations quand l'utilisateur vient de se connecter
    if (!prevUser.current && user) {
      setShowCongrats(true);
      setTimeout(() => setShowCongrats(false), 3000);
    }
    prevUser.current = user;
    handleCon(); // Met à jour isCon en fonction de l'état de user (true si user est défini, false sinon)
  }, [user]);

  // Son de notification via AudioContext
  const playNotifSound = useRef(() => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.setValueAtTime(1046, ctx.currentTime + 0.1);
      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.3);
    } catch (e) {
      // Silencieux si AudioContext non supporté
    }
  });

  // Connexion Socket.IO globale pour les notifications en temps réel
  const socketRef = useRef(null);
  useEffect(() => {
    const token = getToken();
    if (!token || !user) {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    socketRef.current = io(process.env.REACT_APP_API_URL, {
      auth: { token },
    });

    // Nouveau message chat
    socketRef.current.on("newMessageNotification", () => {
      setNbnotif(prev => prev + 1);
      setShowNotif(true);
      playNotifSound.current();
    });

    // Notification backend (activation d'annonce, etc.)
    socketRef.current.on("newNotification", () => {
      setNbnotif(prev => prev + 1);
      setShowNotif(true);
      playNotifSound.current();
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [user]);

  useEffect(() => {
    if (!loading && user && (location.pathname === '/ajoutAnnonce'  || location.pathname === '/ajoutAnnonce/container'  || location.pathname === '/ajoutAnnonce/kilo' || location.pathname === '/ajoutAnnonce/success'  || location.pathname === '/showAnnonce'  || location.pathname === '/showStatistique'  || location.pathname === '/showPayment'  || location.pathname === '/showGoChat'  || location.pathname === '/chat'  || location.pathname === '/profil')) {
      setIsAnnonce(true);
    }
    else if (localStorage.length != 0 && (location.pathname === '/ajoutAnnonce'  || location.pathname === '/ajoutAnnonce/container'  || location.pathname === '/ajoutAnnonce/kilo' || location.pathname === '/ajoutAnnonce/success'  || location.pathname === '/showAnnonce'  || location.pathname === '/showStatistique'  || location.pathname === '/showPayment'  || location.pathname === '/showGoChat'  || location.pathname === '/chat'  || location.pathname === '/profil')) {
      setIsAnnonce(true);
    }
    else{
      setIsAnnonce(false);
    }
  }, [loading, location, navigate]);

  const handleCon = ()=>{
    if (user) {
      setIsCon(true)
    } else {
      const sessionData = getSessionData();
      if (sessionData) {
        setIsCon(true);
        setUser(sessionData);
      }
      else setIsCon(false)
    }
  };

  const handleHideNotif = ()=>{
    setShowNotif(false)
    // Charger les notifications et marquer comme vues
    const token = getToken();
    if (token) {
      fetch(`${process.env.REACT_APP_API_URL}/api/notification/getnotifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ startAt: 0 })
      })
      .then(res => res.json())
      .then((result) => {
        if (result.notifs) {
          setNotifications(result.notifs);
        }
        setNotifLoaded(true);
      })
      .catch(() => setNotifLoaded(true));

      // Marquer toutes les notifications comme vues
      fetch(`${process.env.REACT_APP_API_URL}/api/notification/viewnotifs`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).catch(() => {});
    }
  }
  const handleGoNotif = ()=>{
    setNbnotif(0);
  }
  const handleShowNotif = ()=>{
    setShowNotif(true)
  }
  const timeElapsed = (date) => {
    const now = new Date();
    const past = new Date(date);
    const diffInSeconds = Math.floor((now - past) / 1000);
    if (diffInSeconds < 60) return `${diffInSeconds}s`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}min`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}${t('time.daysShort')}`;
  };

  // comportement lorsqu'on change de langue
  const handleLangChange = (e) => {
    const lang = e.target.textContent;
    setSelectedLang(lang);
    const lngCode = lang === 'EN' ? 'en' : 'fr';
    i18n.changeLanguage(lngCode);
    localStorage.setItem('lang', lngCode);
  };
  // comportement lorsqu'on affiche/ferme le popup de connexion
  const handleModalShow = () => {
    setModalShow(true)
  };
  const handleModalHide = () => {
    setModalShow(false)
  };
  // comportement lorsqu'on affiche/ferme le popup de la carte
  const handleModalShow2 = () => {
    setModalShow2(true)
  };
  const handleModalHide2 = () => {
    setModalShow2(false)
  };

  const handleSignOut = async () => {
    try {
      await firebaseSignOut();
      setGoogleCon('');
      clearSession();
      setUser(null);
      navigate('/');
    } catch (error) {
      // Erreur silencieuse
    }
  };
  
  // comportement lorsqu'on affiche/ferme le popup de connexion
  const handleModalShow3 = () => {
    setModalShow3(true)
  };
  const handleModalHide3 = () => {
    setModalShow3(false)
  };
  
  return (
    <>
      <div className={`header${location.pathname !== '/' && location.pathname !== '/service' ? ' header--mobile-blue' : ''}`}>
        <div className='header_left'>
          <NavLink className='header_left_logo' to='/'>
            <img src={logoGrouping} alt='Logo' className='logo' />
            <span>Grouping</span>
          </NavLink>
          {!modalShow3&&<img src={menu} className='header_left_menu' onClick={handleModalShow3}/>}
        </div>
        <div className={`header_right ${isAnnonce ? 'header_right_addAnnonce' : ''} ${isCon ? 'header_right_connected' : ''}`}>
          {/* <img className='header_right_annonce' src={annonce} alt='ajout annonce'/> */}
          {
            !isAnnonce &&
            <div className='link_nav link_nav_link' onClick={handleModalShow2}>
              <FontAwesomeIcon icon={faLocationDot} className="navIcon1"/>
              <span>{t('nav.map')}</span>
            </div>
          }
          {!isCon && 
            <div className='link_nav' onClick={handleModalShow}>
                <span className="link_nav_link">{t('nav.login')}</span>
            </div>
          }
          {!isAnnonce && (!isCon ?
            <div className='link_nav' onClick={handleModalShow}>
                <span className="link_nav_btn">{t('nav.postAd')}</span>
            </div>
            :
            <NavLink  className='link_nav' to='/ajoutAnnonce'>
                <span className="link_nav_btn">{t('nav.postAd')}</span>
            </NavLink>
          )}
          {isCon && 
            <>
                <div className='link_nav link_nav_profile navbar-brand dropdown-toggle' data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" onClick={handleHideNotif}>
                    <img
                      className="link_nav_link"
                      src={(user && user.photoURL && user.photoURL!==null) ? user.photoURL : tofProfil} 
                      onError={(e) => {
                        e.target.src = tofProfil; // tofSubstitution est votre URL d'image de substitution
                      }}
                      width="43.5"
                      height="43.5"
                      alt="profile"
                    />
                    {showNotif && nbnotif>0 && <span className="link_nav_badge">{nbnotif}</span>}
                </div>
                <div className="dropdown-menu link_dropdown">
                    <NavLink className="dropdown-item link_dropdown_item" to='/chat' state={{}} onClick={handleGoNotif}>{t('nav.notifications')} {nbnotif > 0 && <span className="badge badge-dark">{nbnotif}</span>}</NavLink>
                    {notifLoaded && notifications.length > 0 && (
                      <div className="link_dropdown_notifs">
                        {notifications.slice(0, 5).map((notif, index) => (
                          <div key={notif._id || index} className="link_dropdown_notif_item">
                            <div className="link_dropdown_notif_item_content">
                              <strong>{notif.title}</strong>
                              <p>{notif.body}</p>
                            </div>
                            <span className="link_dropdown_notif_item_time">{timeElapsed(notif.date)}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    <NavLink className="dropdown-item link_dropdown_item" to='/profil'>{t('nav.myProfile')}</NavLink>
                    <NavLink className="dropdown-item link_dropdown_item" to='/showAnnonce'>{t('nav.myAds')}</NavLink>
                    <span className="dropdown-item link_dropdown_item" onClick={handleSignOut}>{t('nav.logout')}</span>
                </div>
            </>
          }
          <div className='link_nav link_nav_mob'>
            <span className="dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
              {selectedLang==="FR" ? (<span className="fi fi-fr"></span>) : (<span className="fi fi-gb"></span>)}
              <span className="codeLang">{selectedLang}</span>
            </span>
            <ul className="dropdown-menu">
              {langs.filter(lang => lang !== selectedLang).map((lang, index) => (
                <li key={index} className="dropdown-item" onClick={handleLangChange}>
                  {lang}
                </li>
              ))}
            </ul>
          </div>
          {!isCon && <img src={logoOmbre} className='header_right_annonce'/>}
        </div>
      </div>
      {!isCon &&
        <SectionConnexion googleCon={googleCon} setGoogleCon={setGoogleCon} show={modalShow} onHide={handleModalHide}/>
        }
      <SectionTracking show={modalShow2} onHide={handleModalHide2}/>
      <MenuMobile user={user} isCon={isCon} show={modalShow3} onHide={handleModalHide3} onSignOut={handleSignOut} onShowLogin={handleModalShow} onShowTracking={handleModalShow2} nbnotif={nbnotif} setNbnotif={setNbnotif}/>
      <Modal className="ModalCongrats" show={showCongrats} onHide={() => setShowCongrats(false)} centered>
        <Modal.Body className="ModalCongrats_body">
          <FontAwesomeIcon icon={faCheckCircle} className="ModalCongrats_icon"/>
          <span className="ModalCongrats_text">{t('auth.congratsConnected')}</span>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Navigation;
